export const flattenTree = <T>(tree: T, field: keyof typeof tree): Array<T> => {
  return [tree, ...((tree[field] ?? []) as Array<T>).flatMap((subtree) => flattenTree(subtree, field))];
};
